<template>
  <div class="interstitialCtaItem">
    <div class="text">
      <div class="titleAndTag">
        <span class="tag">
          {{ result?.category }}
        </span>

        <span class="title">
          {{ result?.title }}
        </span>
      </div>

      <div class="linkWrapper">
        <a :href="result.url" class="ctaLink" :aria-label="result?.title">
          <span>
            {{
              result?.customButtonLabel
                ? result?.customButtonLabel
                : $t("Web.Containers.ReadMore")
            }}
          </span>
        </a>
      </div>
    </div>

    <div class="image">
      <picture>
        <source :srcset="result?.imageDesktop" media="(min-width: 767px)" />
        <source :srcset="result?.imageTablet" media="(min-width: 500px)" />
        <source :srcset="result?.imageMobile" media="(min-width: 0px)" />
        <img
          v-if="result?.imageDesktop"
          :src="result?.imageDesktop"
          alt=""
          role="presentation"
        />
        <img v-else src="/assets/images/Placeholder.png" />
      </picture>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType } from "vue";
import { InterstitialCta } from "../../clients/search/src/models";

export default defineComponent({
  props: {
    result: {
      type: Object as PropType<InterstitialCta>,
      required: true,
      default: (): InterstitialCta => { return {} }
    }
  },
  computed: {
    resultUrl() {
      const urlParts: string[] = [window.location.origin, this.result?.url];

      return urlParts
        .map(url => (url ? url.replace(/^\/+|\/+$/g, "") : ""))
        .join("/");
    }
  }
});
</script>
